import Header from "../../structures/header/index";
import Footer from "../../structures/footer/index";
import "../../../assets/css/about.css";

const IMG_STUDIO = "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80";


export default function AboutPage() {
  return (
    <>
      <Header activePage="about" />

      <main className="ab-main">

        {/* ══════════════════════════════
            HERO
        ══════════════════════════════ */}
        <section className="ab-hero digital-grid">
          <div className="ab-container">
            <div className="ab-hero__grid">

              <div className="ab-hero__left">
                <span className="ab-hero__label">Our Philosophy</span>
                <h1 className="ab-hero__title">
                  Crafting Digital <br /> Light in the Dark
                </h1>
              </div>

              <div className="ab-hero__right">
                <p className="ab-hero__desc">
                  Kami tidak sekadar membangun antarmuka. Kami merancang pengalaman dari kekosongan digital, menggunakan presisi dan cahaya untuk membimbing pengguna melewati kompleksitas.
                </p>
              </div>

            </div>
          </div>
          {/* decorative blur */}
          <div className="ab-hero__blur" aria-hidden="true" />
        </section>

        {/* ══════════════════════════════
            COMPANY HISTORY
        ══════════════════════════════ */}
        <section className="ab-history">
          <div className="ab-container">
            <div className="ab-history__grid">
              {/* Left — Visi & Misi */}
              <div className="ab-history__left">
                <h2 className="ab-history__title">Visi & Misi</h2>
                <div className="ab-history__timeline">
                  <div className="ab-timeline__item">
                    <span className="ab-timeline__year">Visi</span>
                    <p className="ab-timeline__desc">
                      Menjadi mitra utama bagi pelaku UMKM, restoran, cafe, dan perusahaan yang ingin bertransformasi digital, dengan menghadirkan solusi teknologi yang presisi, efisien, dan mudah diadopsi.
                    </p>
                  </div>
                  <div className="ab-timeline__item">
                    <span className="ab-timeline__year">Misi</span>
                    <p className="ab-timeline__desc">
                      1. Membantu UMKM, restoran, cafe, dan perusahaan dalam mengatasi masalah operasional seperti proses yang lambat, pembukuan manual, atau pelayanan yang kurang efisien.
                      <br />2. Mengembangkan sistem digital yang mudah digunakan, terjangkau, dan dapat diintegrasikan sesuai kebutuhan bisnis.
                      <br />3. Memberikan edukasi dan pendampingan agar setiap klien mampu memaksimalkan potensi teknologi untuk pertumbuhan usaha mereka.
                      <br />4. Menjadi solusi terpercaya untuk digitalisasi bisnis di berbagai sektor.
                    </p>
                  </div>
                </div>
              </div>
              {/* Right — image */}
              <div className="ab-history__img-wrap">
                <img
                  src={IMG_STUDIO}
                  alt="High-tech studio architecture with dramatic lighting"
                  className="ab-history__img"
                />
                <div className="ab-history__img-overlay" />
              </div>
            </div>
          </div>
        </section>

        {/* ══════════════════════════════
            L.U.N.E PHILOSOPHY — BENTO
        ══════════════════════════════ */}
        <section className="ab-lune">
          <div className="ab-container">
            <div className="ab-lune__header">
              <h2 className="ab-lune__title">Makna & Filosofi Nama</h2>
              <p className="ab-lune__desc">
                Codelune merupakan gabungan dari dua kata yang saling melengkapi:
              </p>
            </div>
            <div className="ab-bento ab-bento--philosophy">
              {/* Code */}
              <div className="ab-bento__card ab-bento__card--lumi ab-bento__card--hover-line">
                <div>
                  <span className="material-symbols-outlined ab-bento__icon">code</span>
                  <h3 className="ab-bento__card-title">Code</h3>
                  <p className="ab-bento__card-desc">
                    Simbol teknologi, pemrograman, sistem, dan inovasi digital.
                  </p>
                </div>
                <div className="ab-bento__line-bar" />
              </div>
              {/* Lune */}
              <div className="ab-bento__card ab-bento__card--utility ab-bento__card--tall">
                <div className="ab-bento__utility-inner">
                  <span className="material-symbols-outlined ab-bento__icon">dark_mode</span>
                  <h3 className="ab-bento__card-title">Lune</h3>
                  <p className="ab-bento__card-desc">
                    Dari bahasa Prancis "bulan" — melambangkan keindahan, ketenangan, kreativitas, dan cahaya dalam gelap.
                  </p>
                </div>
                <span
                  className="material-symbols-outlined ab-bento__utility-bg"
                  aria-hidden="true"
                >
                  dark_mode
                </span>
              </div>
              {/* Filosofi */}
              <div className="ab-bento__card ab-bento__card--nuance">
                <h3 className="ab-bento__nuance-num">∞</h3>
                <h4 className="ab-bento__card-title">Filosofi</h4>
                <p className="ab-bento__nuance-sub">
                  Codelune adalah simbol karya digital yang tidak hanya fungsional, tetapi juga indah, elegan, dan memberi cahaya di tengah kompleksitas dunia teknologi.
                </p>
              </div>
              {/* Makna Mendalam */}
              <div className="ab-bento__card ab-bento__card--ethos">
                <div className="ab-bento__ethos-text">
                  <h3 className="ab-bento__card-title">Makna Mendalam</h3>
                  <p className="ab-bento__card-desc">
                    Nama ini mencerminkan bahwa setiap produk yang dibangun — website, aplikasi, sistem, portofolio — bukan sekadar teknis, tetapi memiliki nilai estetika dan pengalaman yang berkesan bagi pengguna.
                  </p>
                </div>
                <div className="ab-bento__ethos-ring" aria-hidden="true">
                  <div className="ab-bento__ethos-spinner" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ══════════════════════════════
            CTA
        ══════════════════════════════ */}
        <section className="ab-values">
          <div className="ab-container">
            <div className="ab-lune__header" style={{ marginBottom: '2.5rem' }}>
              <h2 className="ab-lune__title">Nilai Utama</h2>
              <p className="ab-lune__desc">Empat nilai utama yang menjadi fondasi setiap solusi digital yang kami hadirkan.</p>
            </div>
            <div className="ab-bento ab-bento--values">
              {/* Creativity */}
              <div className="ab-bento__card ab-bento__card--lumi ab-bento__card--hover-line">
                <div>
                  <span className="material-symbols-outlined ab-bento__icon">lightbulb</span>
                  <h3 className="ab-bento__card-title">Creativity</h3>
                  <p className="ab-bento__card-desc">Kreativitas dalam setiap solusi digital yang dihadirkan.</p>
                </div>
                <div className="ab-bento__line-bar" />
              </div>
              {/* Elegance */}
              <div className="ab-bento__card ab-bento__card--utility ab-bento__card--tall">
                <div className="ab-bento__utility-inner">
                  <span className="material-symbols-outlined ab-bento__icon">styler</span>
                  <h3 className="ab-bento__card-title">Elegance</h3>
                  <p className="ab-bento__card-desc">Keindahan desain sebagai bagian tidak terpisahkan dari fungsi.</p>
                </div>
                <span className="material-symbols-outlined ab-bento__utility-bg" aria-hidden="true">brush</span>
              </div>
              {/* Innovation */}
              <div className="ab-bento__card ab-bento__card--nuance">
                <h3 className="ab-bento__nuance-num">03</h3>
                <h4 className="ab-bento__card-title">Innovation</h4>
                <p className="ab-bento__nuance-sub">Teknologi mutakhir sebagai alat, bukan tujuan.</p>
              </div>
              {/* Clarity */}
              <div className="ab-bento__card ab-bento__card--ethos">
                <div className="ab-bento__ethos-text">
                  <h3 className="ab-bento__card-title">Clarity</h3>
                  <p className="ab-bento__card-desc">Solusi yang jelas, transparan, dan efektif untuk klien.</p>
                </div>
                <div className="ab-bento__ethos-ring" aria-hidden="true">
                  <div className="ab-bento__ethos-spinner" />
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}